import { action, createRequestTypes } from './base';

export const ocrActionTypes = {
  UPLOAD_DOCUMENT_OCR: createRequestTypes('UPLOAD_DOCUMENT_OCR'),
};

class OCRActions {

  /**
  * @param payload
  * @param callback
  * @return {{type: *}}
  */
  uploadDocumentOCR = (payload, callback) => action(ocrActionTypes.UPLOAD_DOCUMENT_OCR.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param uploadDocumentOCRLoading
   * @return {{type: *}}
   */
  uploadDocumentOCRLoading = (uploadDocumentOCRLoading) => action(ocrActionTypes.UPLOAD_DOCUMENT_OCR.LOADING, {
    uploadDocumentOCRLoading,
  })

  /**
  *
  * @param ocrData
  * @return {{type: *}}
  */
  createSellerSuccess = (ocrData) => action(ocrActionTypes.UPLOAD_DOCUMENT_OCR.SUCCESS, {
    ocrData,
  })
}

export default new OCRActions();
